import type { IBaseComponentProps } from 'components/base/types'
import type { Full } from '@/types/macros'
import type { Vector } from 'math'
import type { SVGAttributes } from 'vue'

export type SVGFunctionProps = Omit<IBaseComponentProps & Partial<SVGAttributes>, 'points' | 'commands'> & { key?: string }

export type SVGPathBaseCommand = {
  _cmd_: 1
}

export type SVGCommandMoveToArgs = {
  point: Vector
}
export type SVGCommandMoveTo = SVGCommandMoveToArgs & SVGPathBaseCommand & {
  key: 'M'
}

export type SVGCommandLineToArgs = {
  moveTo?: Vector;
  point: Vector
}
export type SVGCommandLineTo = SVGCommandLineToArgs & SVGPathBaseCommand & {
  key: 'L'
}

export type SVGCommandCurveToArgs = {
  control: [Vector, Vector];
  end: Vector;
}
export type SVGCommandCurveTo = SVGCommandCurveToArgs & SVGPathBaseCommand & {
  key: 'C'
}

export type SVGCommandSmoothCurveToArgs = {
  control: [Vector];
  end: Vector;
}
export type SVGCommandSmoothCurveTo = SVGCommandSmoothCurveToArgs & SVGPathBaseCommand & {
  key: 'S'
}

export type SVGCommandQuadraticCurveArgs = {
  control: [Vector, Vector];
  end: Vector;
}
export type SVGCommandQuadraticCurve = SVGCommandQuadraticCurveArgs & SVGPathBaseCommand & {
  key: 'Q'
}

export type SVGCommandSmoothQuadraticCurveArgs = {
  control: [Vector];
  end: Vector;
}
export type SVGCommandSmoothQuadraticCurve = SVGCommandSmoothQuadraticCurveArgs & SVGPathBaseCommand & {
  key: 'T'
}

export type SVGCommandArcToArgs = {
  point: Vector;
  rotation?: number;
  large?: boolean;
  sweep?: boolean;
  end: Vector;
}
export type SVGCommandArcTo = Full<SVGCommandArcToArgs> & SVGPathBaseCommand & {
  key: 'A'
}

export type SVGCommandCloseArgs = {}
export type SVGCommandClose = SVGCommandCloseArgs & SVGPathBaseCommand & {
  key: 'Z'
}

export type SVGCommandRawArgs = {
  value: string;
}
export type SVGCommandRaw = SVGCommandRawArgs & SVGPathBaseCommand & {
  key: 'RAW'
}

export type SVGPathCommand =
  | SVGCommandMoveTo
  | SVGCommandLineTo
  | SVGCommandCurveTo
  | SVGCommandSmoothCurveTo
  | SVGCommandQuadraticCurve
  | SVGCommandSmoothQuadraticCurve
  | SVGCommandArcTo
  | SVGCommandClose
  | SVGCommandRaw


export const isSVGPathCommand = (x: any): x is SVGPathCommand => {
  if (!x) return false;
  if (typeof x !== 'object') return false;
  return x._cmd_ === 1;
}

export const isSVGPathCommandArray = (x: any): x is Array<SVGPathCommand> => {
  if (x === null || x === undefined) return false;
  if (!Array.isArray(x)) return false;
  return x.filter(it => isSVGPathCommand(it) === true).length >= x.length;
}
